<div class="legend-content flex mt-4">
    <div class="currency flex flex-column align-items-start pr-3">
      {{
        currency
          | currency : "BRL" : "symbol" : "1.2-2"
      }}
      <span class="subtitle"> Receita mês {{ date | date:"MM/yyyy" }}</span>
    </div>
    <div
      class="previous flex flex-column align-items-start justify-content-center pl-3"
    >
      {{
        previous
          | currency : "BRL" : "symbol" : "1.2-2"
      }}
      <span class="subtitle"> Receita mês anterior {{ previousDate | date:"MM/yyyy" }} </span>
    </div>
</div>
